import React from 'react';
import styled, { css } from 'styled-components';
import { Color, Grid, Shadow, Type } from '../../../app/StyleGuide';

const PillContainer = styled.div<{ visible: boolean }>`
  position: fixed;
  bottom: ${Grid._6};
  left: 50%;
  z-index: 1000;
  transition: transform 0.3s ease, opacity 0.3s ease;

  ${({ visible }) =>
    visible
      ? css`
          transform: translateX(-50%) translateY(0);
          opacity: 1;
        `
      : css`
          transform: translateX(-50%) translateY(calc(100% + 48px));
          opacity: 0;
          pointer-events: none;
        `}
`;

const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: ${Grid._3};
  padding: ${Grid._3} ${Grid._5};
  background: ${Color.white};
  border: 1px solid ${Color.Gray._20};
  border-radius: 100px;
  box-shadow: ${Shadow.medium};
  cursor: pointer;
  font-size: ${Type.Scale._2};
  font-weight: ${Type.Weight.medium};
  color: ${Type.Color.dark};
  white-space: nowrap;

  &:hover {
    background: ${Color.Gray._10};
  }

  i {
    font-size: ${Type.Scale._3};
    color: ${Type.Color.medium};
  }
`;

type SegmentPillNavProps = {
  visible: boolean;
  onClick: () => void;
  title: string;
};

export const SegmentPillNav = ({ visible, onClick, title }: SegmentPillNavProps) => (
  <PillContainer visible={visible}>
    <Pill type="button" onClick={onClick}>
      <i className="fas fa-list"></i>
      {title}
    </Pill>
  </PillContainer>
);
